import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions";

import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductAddToListLink from "@tSurya/Overrides/Components/ProductAddToListLink";
import ProductListProductImage from "@tSurya/Overrides/Widgets/ProductList/ProductListProductImage";
import React, { FC } from "react";
import { css } from "styled-components";

export interface OwnProps {
    showAddToListHeart?: boolean;
}

type Props = ProductCardSelections & HasProduct & OwnProps;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    addtolistStyles?: InjectableCss;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
            position: relative;
            @keyframes fade-in {
                0% {
                    opacity: 0;
                }
                100% {
                    opacity: 1;
                }
            }
            animation: fade-in 1s ease;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: 12px;
                        `,
                        css`
                            padding-bottom: 12px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },

    addtolistStyles: {
        css: css`
            position: absolute;
            bottom: 12%;
            right: 3%;
        `,
    },

    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    showAddToListHeart,
}) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            <StyledWrapper {...styles.imageWrapper}>
                {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                <ProductListProductImage
                    showImage={showImage}
                    showCompare={showCompare}
                    showImageBadge={showImageBadges}
                    showTextBadge={showTextBadges}
                    maximumNumberOfTextBadges={maximumNumberOfTextBadges}
                    showAddToListIcon={showAddToListHeart}
                />
                {/* <StyledWrapper {...styles.addtolistStyles}>
                    <ProductAddToListLink showIcon={true}></ProductAddToListLink>
                </StyledWrapper> */}
            </StyledWrapper>
            {/* <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            /> */}
            {/* <ProductListActions showAddToList={showAddToList} showPrice={showPrice} /> */}
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
